import type { ReactNode } from 'react'

import React from 'react'

import { Button } from '@/shared/components/ui/button'
import { StateButton } from '@/shared/components/ui/state-button'

type FilterButtonProps = {
	children: ReactNode
	isInvalid: boolean
	isSelected: boolean
	onClick?(): void
	onClear?(): void
	ref?: React.Ref<HTMLButtonElement>
}

export const FilterButton = ({
	children,
	isInvalid,
	isSelected,
	onClick,
	onClear,
	ref,
}: FilterButtonProps) =>
	onClear ? (
		<StateButton
			variant={isInvalid ? 'destructive' : 'ghost'}
			size='sm'
			onClick={onClick}
			onClear={onClear}
			active={!!onClear}
			ref={ref}
		>
			{children} {isInvalid ? '(!)' : ''}
		</StateButton>
	) : (
		<Button
			variant={isInvalid ? 'destructive' : 'dashed'}
			size='sm'
			onClick={onClick}
			data-active={isSelected}
			ref={ref}
		>
			{children} {isInvalid ? '(!)' : ''}
		</Button>
	)
